// extracted by mini-css-extract-plugin
export default {"sheetViewWrapper":"SheetView_sheetViewWrapper__FQ0Ut","statusBox":"SheetView_statusBox__-jThc"};